import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

import { AuthGuard } from '~/auth/guards/auth.guard';
import { OrganizerSharedPageOverviewComponent } from '~/organizer/shared/components/pages/overview/overview.component';
import { OrganizerSharedClearTimeslotGuard } from '~/organizer/shared/guards/clear-timeslot/clear-timeslot.guard';
import { OrganizerSharedGetActivityByQueryIdGuard } from '~/organizer/shared/guards/get-activity-by-query-id/get-activity-by-query-id.guard';
import { OrganizerSharedGetOrganizationByQueryIdGuard } from '~/organizer/shared/guards/get-organization-by-query-id/get-organization-by-query-id.guard';
import { OrganizerSharedGetOrganizationFromAuthUserGuard } from '~/organizer/shared/guards/get-organization-from-auth-user/get-organization-from-auth-user.guard';
import { OrganizerSharedHasActivityGuard } from '~/organizer/shared/guards/has-activity/has-activity.guard';
import { OrganizerSharedHasOrganizationGuard } from '~/organizer/shared/guards/has-organization/has-organization.guard';
import { OrganizerActivityPlanningPageActivityComponent } from './components/pages/activity/activity.component';
import { OrganizerActivityPlanningPageMyPlanningValidationComponent } from './components/pages/my-planning-validation/my-planning-validation.component';

const routes: Routes = [
  {
    path: 'organizer.activity-planning.steps-2',
    component: OrganizerSharedPageOverviewComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedHasActivityGuard,
      OrganizerSharedClearTimeslotGuard,
    ],
  },
  {
    path: 'organizer.activity-planning.activity',
    component: OrganizerActivityPlanningPageActivityComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedHasActivityGuard,
      OrganizerSharedClearTimeslotGuard,
    ],
  },
  {
    path: 'organizer.activity-planning.my-planning-validation',
    component: OrganizerActivityPlanningPageMyPlanningValidationComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedHasActivityGuard,
      OrganizerSharedClearTimeslotGuard,
    ],
  },
];

/**
 * Prefix route of the sub modules
 */
@NgModule({
  imports: [
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
  exports: [RouterModule, LocalizeRouterModule],
})
export class OrganizerActivityPlanningRoutingModule {}
